module.exports = __webpack_public_path__ + "static/assets/4cb5b3f7da25105c8c56c727217ef40c.svg";